import { ISubstanceByStoreDTO, ISubstanceDTO, ISubstanceViewDTO } from "../../../libs/coreapi-dto/dirs/substance";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";
import { ContentType } from "../../fetchApiDistributor/contentTypes";


interface ISubstanceCreate extends ISubstanceDTO {
}
interface ISubstanceUpdate extends ISubstanceDTO{
}

class SubstanceRequest extends BaseDirRequest<ISubstanceViewDTO, ISubstanceDTO> {

    constructor(baseUrl:string, token:string, eventHandler: IRequestEventHandler){
        super(baseUrl, "substance", token, eventHandler)
    }

    create(body: ISubstanceCreate, callback: (e:CoreApiResponse<string>)=>void){
        super.create(body,callback)
    }
    
    update(idGlobal:string, body: ISubstanceUpdate, callback: (e:CoreApiResponse<null>)=>void){
        super.update(idGlobal,body,callback)
    }
    
    getDistinctViewByStore(body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<ISubstanceByStoreDTO>>) => void, signal?: AbortSignal | null) {        
        this.post<IViewWrapper<ISubstanceByStoreDTO>>(`${this._baseUrl}/${this._routePrefix}/DistinctViewByStore`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }, signal)
    }
}

export default SubstanceRequest